//登录
import Login from '@/views/my/login'
//忘记密码
import Forgotpwd from '@/views/my/forgotpwd'
// 首页
import Index from '@/views/index'
// 基础数据
import Basic from '@/views/datas/basic'
// 职位列表
import Position from '@/views/position/positionlist'
// 投递人数列表
import DeliveryNumber from '@/views/position/deliveryNumber'
// 职位详情
import PositionDetails from '@/views/position/positionDetails'
// 简历列表
import Resume from '@/views/resume/resumelist'
// 简历详情
import ResumeDetails from '@/views/resume/resumedetails'
// 人才搜索
import Personnel from '@/views/resume/personnelsearch'
// 人才搜索结果
import PersonnelResult from '@/views/resume/personnelsearchresult'
// 角色权限
import RoleJurisdiction from '@/views/role/roleJurisdiction'
// 账号管理
import Accountmanagement from '@/views/role/accountmanagement'
// 我的收藏
import Collection from '@/views/collection/list'
// 个人中心
import Mymsg from '@/views/my/mymsg'
//报名
import SignUp from '@/views/signUp/index'//停用
//广告
import Advert from '@/views/advert/index'

const routers = [{
    path: "/",
    name: "Index",
    component: Index,
    redirect: '/mymsg',
    meta: {
        record: [],
        keepAlive: false
    },
    children: [{
        path: "/mymsg",
        name: 'Mymsg',
        component: Mymsg,
        meta: {
            record: [],
            keepAlive: false
        },
    },
    {
        path: "/basic",
        name: 'Basic',
        component: Basic,
        meta: {
            record: [{
                title: "数据中心"
            },
            {
                title: "基础数据"
            }],
            keepAlive: false
        },
    },
    {
        path: "/positionlist",
        name: 'Position',
        component: Position,
        meta: {
            record: [{
                title: "职位管理"
            },
            {
                title: "职位列表"
            }],
            keepAlive: true
        }
    },
    {
        path: "/deliverynumber",
        name: 'DeliveryNumber',
        component: DeliveryNumber,
        meta: {
            record: [{
                title: "职位管理"
            },
            {
                title: "职位列表",
                path: "/positionlist"
            },
            {
                title: "投递人数列表"
            }],
            keepAlive: false
        }
    },
    {
        path: "/positiondetails",
        name: 'PositionDetails',
        component: PositionDetails,
        meta: {
            record: [{
                title: "职位管理"
            },
            {
                title: "职位列表",
                path: "/positionlist"
            },
            {
                title: "职位详情"
            }],
            keepAlive: false
        }
    },
    {
        path: "/resumelist",
        name: 'Resume',
        component: Resume,
        meta: {
            record: [{
                title: "简历管理"
            },
            {
                title: "简历列表"
            }],
            keepAlive: true
        }
    },
    {
        path: "/resumedetails",
        name: "ResumeDetailsForList",
        component: ResumeDetails,
        meta: {
            record: [{
                title: "简历管理"
            },
            {
                title: "简历列表",
                path: "/resumelist"
            },
            {
                title: "简历详情"
            }],
            keepAlive: false
        }
    },
    {
        path: "/personnelsearch",
        name: 'Personnel',
        component: Personnel,
        meta: {
            record: [{
                title: "简历管理"
            },
            {
                title: "人才搜索"
            }
        ],
            keepAlive: true
        }
    },
    {
        path: "/personnelsearchresult",
        name: 'PersonnelResult',
        component: PersonnelResult,
        meta: {
            record: [{
                title: "简历管理"
            },
            {
                title: "人才搜索",
                path: "/personnelsearch"
            },
            // {
            //     title: "人才搜索结果"
            // }
        ],
            keepAlive: true
        }
    },
    {
        path: "/resumedetails",
        name: "ResumeDetailsForSearch",
        component: ResumeDetails,
        meta: {
            record: [{
                title: "简历管理"
            },
            {
                title: "人才搜索",
                path: "/personnelsearch"
            },
            // {
            //     title: "人才搜索结果",
            //     path: "/personnelsearchresult"
            // },
            {
                title: "简历详情"
            }],
            keepAlive: false
        }
    },
    {
        path: "/collection",
        name: 'Collection',
        component: Collection,
        meta: {
            record: [{
                title: "我的收藏"
            },
            {
                title: "收藏列表"
            }],
            keepAlive: false
        },
    },
    {
        path: "/roleJurisdiction",
        name: 'RoleJurisdiction',
        component: RoleJurisdiction,
        meta: {
            record: [{
                title: "权限与账号"
            },
            {
                title: "角色权限"
            }],
            keepAlive: false
        }
    },
    {
        path: "/accountmanagement",
        name: 'Accountmanagement',
        component: Accountmanagement,
        meta: {
            record: [{
                title: "权限与账号"
            },
            {
                title: "账号管理"
            }],
            keepAlive: false
        }
    },
    {
        path: "/404",
        name: "notFound",
        component: () => import('@/views/404'),
        meta: {
            record: [],
            keepAlive: false
        }
    }]
},
{
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
        record: [],
        keepAlive: false
    }
  },
  {
    path: "/forgotpwd",
    name: "Forgotpwd",
    component: Forgotpwd,
    meta: {
        record: [],
        keepAlive: false
    }
},
{
  path: "/signUp",
  name: "SignUp",
  component: SignUp,
  meta: {
      record: [],
      keepAlive: false
  }
},
{
  path: "/advert",
  name: "Advert",
  component: Advert,
  meta: {
      record: [],
      keepAlive: false
  }
},
{
    path: "*",
    component: Error,
    redirect: '/404'
}]


export {
    routers
}



// WEBPACK FOOTER //
// ./src/router/config.js